import React from 'react'
import { useSelector } from 'react-redux'

import { TbLoader2 } from 'react-icons/tb'

import JobApplicationList from './JobApplicationList'
import JobApplicantDetails from './JobApplicantDetails'
import NoSelectUser from './NoSelectUser'
import { jobApplicantState } from '../store/jobApplicant.slice'

import styles from '../jobApplications.module.css'

const JobApplications = ({
    state,
    setState,
    canEdit = true,
}) => {
    const jobApplicantStateData = useSelector(jobApplicantState)
    const isInitialLoading =
        jobApplicantStateData?.loaders?.applicantLoading &&
        !(jobApplicantStateData?.applicantList?.length > 0)

    return (
        <div className={styles.workspaceHost}>
            {isInitialLoading ? (
                <div className={styles.centeredState}>
                    <TbLoader2
                        size={30}
                        className="spin-loader-resume"
                        color="#4f46e5"
                    />
                </div>
            ) : (
                <div className={styles.workspace}>
                    <div className={styles.listPane}>
                        <JobApplicationList state={state} setState={setState} />
                    </div>
                    <div className={styles.detailPane}>
                        {state?.selectedApplicantData ? (
                            <JobApplicantDetails
                                state={state}
                                setState={setState}
                                canEdit={canEdit}
                            />
                        ) : (
                            <NoSelectUser />
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default JobApplications
